import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import image404 from '../asset/image/image_404.png';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const duration = 10000; // 10초

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + (100 / (duration / 100));
        if (newProgress >= 100) {
          clearInterval(interval);
          navigate('/');
          return 100;
        }
        return newProgress;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="not-found-container" role="main">
      <div className="not-found-content">
        <img src={image404} alt="404 Error" className="not-found-icon" />
        <h1 id="not-found-title" className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-description" aria-live="polite">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="not-found-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
        <div className="not-found-actions" aria-label="404 page navigation">
          <Link 
            to="/" 
            className="btn-rtg btn-primary"
            aria-label="Return to home page"
          >
            Go to Home
          </Link>
        </div>
      </div>
      <style jsx>{`
        .not-found-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex; 
          justify-content: center; 
          align-items: center;
          background-color: rgba(255, 255, 255, 0.95);
          z-index: 9999;
          padding: 20px;
          box-sizing: border-box;
        }
        
        .not-found-content {
          text-align: center;
          display: flex; 
          flex-direction: column; 
          align-items: center;
          gap: 16px;
          max-width: 500px;
        }
        
        .not-found-icon {
          width: 250px;
          height: auto;
          max-width: 100%;
          margin-bottom: 8px;
          object-fit: contain;
        }
        
        .not-found-title {
          font-size: 4rem;
          font-weight: 700;
          margin: 0;
          color: #2d3748;
          line-height: 1;
        }
        
        .not-found-subtitle {
          font-size: 1.5rem;
          font-weight: 600;
          margin: 0;
          color: #4a5568;
        }
        
        .not-found-description {
          font-size: 16px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        
        .not-found-progress {
          width: 100%;
          max-width: 300px;
        }
        
        .progress-bar {
          width: 100%;
          height: 4px;
          background-color: var(--color-monotone-1, #e2e8f0);
          border-radius: 2px;
          overflow: hidden;
        }
        
        .progress-fill {
          height: 100%;
          background-color: var(--color-primary, #4299e1);
          border-radius: 2px;
          transition: width 0.1s ease;
        }
        
        .not-found-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          margin-top: 0;
          width: 100%;
        }
        
        .not-found-button {
          padding: 12px 24px;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 120px;
          text-decoration: none;
          display: inline-block;
        }
        
        .not-found-button.primary {
          background: var(--color-primary, #4299e1);
          color: white;
        }
        
        .not-found-button.primary:hover {
          background: var(--color-primary-dark, #3182ce);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(66, 153, 225, 0.4);
        }
        
        .not-found-button.primary:active {
          transform: translateY(0);
        }
        
        /* btn-rtg btn-primary 클래스 스타일 */
        .btn-rtg.btn-primary {
          padding: 12px 24px;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 120px;
          text-decoration: none;
          display: inline-block;
          background: var(--color-primary, #4299e1);
          color: white;
        }
        
        .btn-rtg.btn-primary:hover {
          background: var(--color-primary-dark, #3182ce);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(66, 153, 225, 0.4);
        }
        
        .btn-rtg.btn-primary:active {
          transform: translateY(0);
        }
        
        /* Responsive design */
        @media (max-width: 640px) {
          .not-found-title {
            font-size: 3rem;
          }
          
          .not-found-subtitle {
            font-size: 1.2rem;
          }
          
          .not-found-actions {
            flex-direction: column;
            width: 100%;
          }
          
          .not-found-button,
          .btn-rtg.btn-primary {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;
